import { render, staticRenderFns } from "./Month.vue?vue&type=template&id=986d4a2a&scoped=true&"
import script from "./Month.vue?vue&type=script&lang=js&"
export * from "./Month.vue?vue&type=script&lang=js&"
import style0 from "./Month.vue?vue&type=style&index=0&id=986d4a2a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986d4a2a",
  null
  
)

export default component.exports